import {
    combineMatchOptions,
    type SlateEditor,
    TextApi,
} from '@udecode/plate';

import { BaseSuggestionPlugin } from '../BaseSuggestionPlugin';
import type { TSuggestionText } from '../types';
import { getSuggestionKeys } from '../utils/getSuggestionKeys';

export const countSuggestions = (editor: SlateEditor): number => {
    const uniqueSuggestionIds = new Set<string>();
    
    const nodes = editor.api.nodes<TSuggestionText>({
        at: [],
        match: combineMatchOptions(
            editor,
            (n) => TextApi.isText(n) && (n as any)[BaseSuggestionPlugin.key],
            {}
        ),
    });

    for (const [node] of nodes) {
        const suggestionKeys = getSuggestionKeys(node);
        for (const key of suggestionKeys) {
            // Extract suggestion ID from key (format: "suggestion_<id>")
            const suggestionId = key.replace(`${BaseSuggestionPlugin.key}_`, '');
            uniqueSuggestionIds.add(suggestionId);
        }
    }

    return uniqueSuggestionIds.size;
};
